<div class="filters-bar">
  <!-- <mat-chip-list aria-label="Filter Series" multiple="true">
    <ng-container *ngFor="let series of seriesSubject | async; let i = index">
      <mat-chip color="primary" [selected]="series.active"
        (click)="seriesClicked(i)">
        {{series.label}}
      </mat-chip>
    </ng-container>
  </mat-chip-list> -->
  <mat-slide-toggle class="toggle" color="primary" 
    [checked]="showPastEventsSubject | async"
    (change)="pastEventsChanged($event)">
    {{'pastEvents' | transloco}}
  </mat-slide-toggle>
</div>

<ul class="events-container">
  <li *ngFor="let event of (filteredEvents$ | async); let i = index"
  class="event">
    <angular-community-event-row [event]="event" [isPastEvent]="showPastEventsSubject | async"></angular-community-event-row>
  </li>
</ul>
